import React, {useState, useEffect, useRef} from 'react'
import { FaPen } from 'react-icons/fa';
import NavBar from "../navbar/navbar.component"
import {useNavigate} from 'react-router-dom'
import { useMyData } from '../../context/data-context.component';
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../utils/firebase"; // adjust paths as needed
import { MdOutlineCheckBoxOutlineBlank} from "react-icons/md";
import { GiCheckMark } from "react-icons/gi";
import Toast from "../toast/toast.component"
import "./my-page.styles.css"


const MyPage = () => {

  const [userData, setUserData] = useState(null);
  const [receiveEmails, setReceiveEmails] = useState(userData?.receiveEmails || false);
  const [nicknameInput, setNicknameInput] = useState("");
  const [showNickNameInput, setShowNickNameInput] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

const nicknameInputRef = useRef(null);

  const {user, loadingUser, userWordsCount, cardsSwipedRef, setUser} = useMyData()

  const navigate = useNavigate()

            
          // useEffect(() => {
          //   console.log({ user, loadingUser });
          // }, [user, loadingUser]);

       useEffect(() => {
          if (user) {
            const userDataObject = {
              email: user.email,
              preference: user.preference || "N/A",
              role: user.role || "N/A",
              displayName: user.displayName || "N/A",
              receiveEmails: user.receiveEmails || false,
              trophiesWon: user.trophiesWon || {},
            };
            setUserData(userDataObject);
            setReceiveEmails(user.receiveEmails || false);
          } else {
            setUserData(null);
          }
      }, [user]);


        useEffect(() => {
          if (user?.displayName) {
            setNicknameInput(user.displayName);
            }}, [user]);

      const showToast = (msg) => {
        setToastMessage(msg);
          };

  
const handleNicknameChange = async () => {
  if (!showNickNameInput) {
    setShowNickNameInput(true);
    return;
  }

  if (!nicknameInput.trim()) {
    showToast("Cannot Be Empty");
    return;
  }

  try {
    const userRef = doc(db, "users", user.uid);
    await setDoc(userRef, { displayName: nicknameInput }, { merge: true });
    setUser(prev => ({ ...prev, displayName: nicknameInput }));
    nicknameInputRef.current?.blur();
    setShowNickNameInput(false);
    showToast("Nickname Updated");
  } catch (error) {
    console.error("Error updating nickname:", error);
  }
};


 const receiveEmailsFunction = async () => {

  if (!user) return;

  const newValue = !receiveEmails
  setReceiveEmails(newValue)

  try {
    const userDocRef = doc(db, "users", user.uid);
    await setDoc(userDocRef, {
      receiveEmails: newValue
    }, { merge: true });
    setUserData((prev) => ({
      ...prev,
      receiveEmails: newValue
    }));
  } catch (error) {
    console.error("Error updating receiveEmails:", error);
    setReceiveEmails(!newValue);
  }
};

const countTrueTrophies = (trophiesWon, role) => {
  if (!trophiesWon || role === "unsubscribed") return 0;

  return Object.values(trophiesWon).reduce((total, gameMap) => {
    const trueCount = Object.values(gameMap).filter((v) => v === true).length;
    return total + trueCount;
  }, 0);
};


  const navToCheckout = () => {
      navigate('/subscribe')
    }

 const unsubscribeFunction = async () => {
  if (user?.role === "subscribed") {
    try {
      const res = await fetch("https://photo-tutor-server.onrender.com/create-customer-portal-session", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ appUserEmail: user.email }),
      });

      const data = await res.json();

      if (data?.url) {
        window.location.href = data.url;
      } else {
        alert("Something went wrong loading your billing portal.");
      }
    } catch (err) {
      console.error("Failed to load portal session:", err);
      alert("Unable to load billing portal. Please try again.");
    }
  }
};


   if (loadingUser || typeof user === "undefined") {
  return (
  <div className = "mp-loading-text">Loading . . . </div>)
}
    if (user === null) {
    return (
      <>
    <NavBar backgroundColor='#f5f7fa'/>
        <div className = "mp-wel-text-wrapper">
        <h1 className = "mypage-welcome-text">Sign In to Display</h1>
        <button
        onClick={() => navigate('/auth')}
        className="homepage-button my-page-button">
          Sign In
          </button>
        </div>
     </>
    )
  }

  if (user) {
  return (
    <>
    <NavBar backgroundColor='#f5f7fa'/>
    <div className = "my-page-introduction">
       {toastMessage && (
      <Toast
        key={toastMessage} // forces remount
        message={toastMessage}
        onClose={() => setToastMessage("")}
      />
    )}
       {/* {showModal && (
        <div className="beta-warning-modal">
          <p>Sorry, still in <br/> beta mode...</p>
          <button 
          style={{ display: "block", margin: "20px auto" }}
          onClick={() => setShowModal(false)}>Okay</button>
        </div>
      )} */}
    <h1 className = "mypage-welcome-text">Your Page</h1>
    <div style={{ textIndent: "2em" }} className = "introduction-text">Hey, it's your very own page!  Here you can see specific information related to your account, track your progress, and manage your subscription.</div>
    

     <div className="user-info-display">
        <div><strong>Email:</strong></div>
        <div>{user.email}</div>

        <div><strong>NickName:</strong></div>
        <div style = {{display: "flex"}}>
        {showNickNameInput ? (
          <input
            ref={nicknameInputRef}
            type="text"
            value={nicknameInput}
            onChange={(e) => setNicknameInput(e.target.value)}
            placeholder="Enter nickname"
          />) : 
          (<div>{user.displayName}</div> )}
          <button onClick={handleNicknameChange} style={{color:"blue", background: 'none', border: 'none', cursor: 'pointer' }}>
            <FaPen size={13} />
          </button>
        </div>



        <div><strong>Role:</strong></div>
        <div>{user.role}</div>

        <div><strong>Preference:</strong></div>
        <div>{user.preference}</div>
    </div>
   
        <div onClick={receiveEmailsFunction} style={{width: "300px", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}>
          <div style={{ position: "relative", width: "38px", height: "38px" }}>
      <MdOutlineCheckBoxOutlineBlank size={30} />
    {receiveEmails && (
      <GiCheckMark
        size={45}
        color="green"
          style={{
          position: "absolute",
          top: "5%",
          left: "70%",
          transform: "translate(-50%, -50%) rotateZ(10deg)",
          // backgroundColor: "white",
          borderRadius: "50%"
        }}
      />
    )}
  </div>

  <span>Receive emails about new video lessons and games</span>
</div>
    <div className="mp-button-group">
      {user.role === "unsubscribed" && (
      <div className = "sales-text">Upgrade to store more words, watch more videos and power up your learning!</div>
      )}
          <div className="mp-button-and-chart">
 <div className={`${user.role === "subscribed" ? 'subscribed' : ''} mp-chart`}>
    <table className="mp-table">
      <tbody>
        <tr>
          <td>Trophies Won</td>
          <td>{countTrueTrophies(user.trophiesWon, user.role)}</td>
        </tr>
        <tr>
          <td>Cards Swiped</td>
          <td>{user.role === "subscribed" ? (cardsSwipedRef.current || 0) : 0}</td>
        </tr>
        <tr>
          <td>Personal List</td>
          <td>{user.role === "subscribed" ? userWordsCount : 0}</td>
        </tr>
      </tbody>
    </table>
  </div>
  {user.role === "unsubscribed" && <button
    onClick={navToCheckout}
    // onClick = {() => setShowModal(true)}
    className="mp-button subscribe-button"
  >
    Subscribe
  </button>}
</div>
{user.role === "subscribed" && <button
    onClick={unsubscribeFunction}
    className="mp-button unsubscribe-button"
  >
    Unsubscribe
  </button>}
    </div>
   </div>
    </>
  )
}
}

export default MyPage



